//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
}
